module.exports = require("./ca-FR.js");